import isNumber from 'lodash/isNumber';
import { TemporalItem } from 'model/menu';

export const validate = (values: any) => {
  const errors: any = {
    name: undefined,
    choices: {
      minimum: undefined,
      maximum: undefined,
    },
    temporalItems: [],
  };
  let hasError = false;
  const items = values.temporalItems.length;

  if (!values.name) {
    errors.name = 'Name is required.';
    hasError = true;
  }

  if (!isNumber(values.choices.minimum)) {
    errors.choices.minimum = `Must be a number.`;
    hasError = true;
  } else if (
    values.choices.minimum < 0 ||
    values.choices.minimum === undefined
  ) {
    errors.choices.minimum = `Can't be negative.`;
    hasError = true;
  } else if (values.choices.minimum > items) {
    errors.choices.minimum = `Can't be greater than total items.`;
    hasError = true;
  }

  if (!isNumber(values.choices.maximum)) {
    errors.choices.maximum = `Must be a number.`;
    hasError = true;
  } else if (values.choices.maximum < 0) {
    errors.choices.maximum = `Can't be negative.`;
    hasError = true;
  } else if (values.choices.maximum < values.choices.minimum) {
    errors.choices.maximum = `Can't be less than minimum.`;
    hasError = true;
  } else if (values.choices.maximum > items) {
    errors.choices.maximum = `Can't be greater than total items.`;
    hasError = true;
  }

  values.temporalItems.forEach((item: TemporalItem, index: number) => {
    if (!item.name) {
      errors.temporalItems[index] = {
        ...errors.temporalItems[index],
        name: 'Name is required.',
      };
      hasError = true;
    }
  });

  return hasError ? errors : undefined;
};

export default validate;
